// 合作伙伴主数据API
export default {
  // 合作伙伴列表
  LIST_PARTNER: '/maindata/partners/listPartner',
  // 合作伙伴扩展列表
  LIST_PARTNEREXTEND: '/maindata/partners/getPartnerExtendByPage',
  // 合作伙伴扩展列表--不过滤重复的
  LIST_PARTNEREXTEND_NO_FILTER: '/maindata/partners/getSupplyPartnerExtendByPage',
  // 合作伙伴名称筛选
  LIST_PARTNER_SEARCH: '/maindata/partners/listPartner',
  // 合作伙伴新增
  SAVE_PARNERS: '/maindata/partners/saveParners',
  // 合作伙伴修改
  UPDATE_PARTNERS: '/maindata/partners/updatePartners',
  // 获取人员信息
  GET_LIST_PERSON: '/maindata/person/listPerson',
  // 合作伙伴扩展申请
  SAVE_PARTNER_EXTEND: '/maindata/partners/savePartnerExtend',
  // 合作伙伴查重
  GET_CHECKING_PARTNER: '/maindata/partners/getCheckingPartner',
  // 合作伙伴名称查重
  IS_EXIST_BY_NAME: '/maindata/partners/isExistByName',
  // 合作伙伴详情
  GET_PARTNER: '/maindata/partners/getPartner',
  // 启用禁用
  UPDATE_IS_PARTNERS: '/maindata/partners/updateIsDeleted',
  //驳回、审批
  UPDATE_IS_REJECT: '/maindata/partners/batchAuditV2',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 合并
  UPDATE_MERGE: '/maindata/partners/updateMerge',
  // 导出合作伙伴
  EXPORT_PARTNER_SELECT_COLUMN: '/maindata/partners/exportPartnerSelectColumn',
  // 导出详情
  EXPORT_PARTNERS_DETAIL: '/maindata/partners/exportPartnersDetail',
  // 获取部门
  DEPARTMENT_LIST: '/maindata/department/listDepartmentByCompanyCode',
  // 导入
  IMPORT_PARTNER: '/maindata/partners/importSysPartiners',
  // 附件上传
  OSS_UPLOAD_API: '/maindata/dict/ossUpload',
  // 币种数据(币种管理)
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  /**获取公司下拉*/
  GET_COMPANY_LIST_API: '/maindata/company/listCompanyDropdown',
  // 所属集团
  LIST_PARTNERCODENAME: '/maindata/partners/listPartnerCodeNameByPage',
  // 同步mdg
  PARTNER_SYNCMDG: '/maindata/partner/sendPartner',
  //保存银行数据、联系人数据、附件数据
  B_P_SAVE: '/maindata/partners/batchSavePartnerBankAndPerson',
  // 查询当前合作伙伴的集团
  GET_PARTNER_GROUP: '/maindata/partners/getExistPartnerInfo',
  // 导入投送人信息补充（证件信息）
  SUPPLEMENT_IMPORT_PARTNER: '/maindata/partners/importDelivererIdentity',
};
